<article class="kanban-card-purchase" (click)="clickCard.emit()">
  <header class="kanban-card-purchase__header" [class.--without-register]="withoutRegister()">
    <h3 class="kanban-card-purchase__header__title">{{ tittle() }}</h3>
    @if (hasConciliationFailure()) {
    <span
      class="kanban-card-purchase__header__warning material-symbols-outlined"
      [pdsTooltip]="conciliationFailureTooltip()"
      (click)="clickConciliationFailure.emit(); $event.stopPropagation()"
    >
      warning
    </span>
    }
  </header>
  <main class="kanban-card-purchase__content">
    <section>
      <p>
        <b>{{ date() | date }}</b>
      </p>
      <b class="kanban-card-purchase__content__amount">{{ amount() | currency : 'BRL' }}</b>
    </section>
    @if(commerceReference()) {
    <section>
      <span>{{ commerceReference() }}</span>
    </section>
    }
    <section>
      <div class="kanban-card-purchase__content__seller">
        <strong>Seller</strong>
        <span #branchNameRef class="truncate-text">{{ branchName() }}</span>
      </div>
      @if (withoutRegister()) {
      <div class="kanban-card-purchase__content__flag">
        <i class="kanban-card-purchase__content__flag__icon icon">warning</i>
        <span>Sem Cadastro</span>
      </div>
      }
    </section>
    <footer class="kanban-card-purchase__footer">
      @if (showRemove()) {
      <button pdsButton="terciary" *allowTo="[['compras-painel-fiscal-edicao']]" (click)="clickRemove.emit(); $event.stopPropagation()">Remover da lista</button>
      }@if (showSendToOmie()) {
      <button pdsButton="primary" *allowTo="[['compras-painel-fiscal-edicao']]" (click)="clickSendOmie.emit(); $event.stopPropagation()">Enviar pro Omie</button>
      }
    </footer>
  </main>
</article>
